import React from 'react';

const Question = () => {
  return <div>In Proccess</div>;
};

export default Question;
